export enum CalibrationType {
	Curve = 1,
	Matrix = 2,
	Both = 3
}

export interface RatingsData {
	groupId: number;
	name: string;
	ratingsDict: RatingDict;
	totalParticipants: number;
}

export interface RatingDict {
	[rating: string]: RatingTotals;
}

export interface NineBoxRatings {
	xAxis: NineBoxRatingDict[];
	yAxis: NineBoxRatingDict[];
}


export interface NineBoxRatingDict {
	value: string | number;
	globalized: { key: 'pt-BR' | 'en-US' | 'es-ES', value: string }[];
}

export interface RatingTotals {
	evaluated: number;
	name: string;
	population: number;
	max: number;
	min: number;
	target: number;
	totalAllowedPeopleMin: number;
	totalAllowedPeopleMax: number;
	totalAllowedPeopleDecimal: number;
}
